module.exports = __webpack_public_path__ + "img/pexels-belle-co-981153.ad741557.jpg";